// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"768be31a","262":"aeb2397f","854":"6e5f98a9"}[chunkId] + ".chunk.css";
};